import "./App.css";
import React, { useState } from "react";
import Header from "../src/Components/Header";
import Clock from "../src/Components/Clock";
import Digitalclock from "./Components/Digitalclock";
import Switch from "@material-ui/core/Switch";
import { Route, Routes } from "react-router-dom";
import Weather from "../src/Weather";
import Enddate from "../src/Components/Enddate";
import Footer from "../src/Components/Footer";

export default function App() {
  const [check, setCheck] = useState(true);

  function CheckHandler() {
    if (check) {
      setCheck(false);
    } else {
      setCheck(true);
    }
  }
  return (
    <div className="App">
      <Header />
      <Routes>
        {check === true ? (
          <Route path="/" element={<Clock />} />
        ) : (
          <Route path="/" element={<Digitalclock />} />
        )}
      </Routes>

      <div className="toggle-switch"></div>
      <Switch
        onClick={() => CheckHandler()}
        defaultChecked
        color="default"
        inputProps={{ "aria-label": "checkbox with default color" }}
      />
      <Weather />
      <Enddate />
      <Footer />
    </div>
  );
}
